/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Feat1_TitleInputs */

const es_l7_feat1_title = /** @type {(inputs: L7_Feat1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio de uso y despacho`)
};

const gl_l7_feat1_title = /** @type {(inputs: L7_Feat1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio de uso e despacho`)
};

const en_l7_feat1_title = /** @type {(inputs: L7_Feat1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change of use and dispatch`)
};

/**
* | output |
* | --- |
* | "Change of use and dispatch" |
*
* @param {L7_Feat1_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_feat1_title = /** @type {((inputs?: L7_Feat1_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Feat1_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_feat1_title(inputs)
	if (locale === "en") return en_l7_feat1_title(inputs)
	return es_l7_feat1_title(inputs)
});